export default "__VITE_ASSET__629f0798__"